import { useScrollAnimation } from '@/hooks/useScrollAnimation';


const skills = [
  { icon: 'ri-palette-line', label: 'Diseño Gráfico', color: '#FF6B35', serviceId: 'service-diseño-gráfico' },
  { icon: 'ri-smartphone-line', label: 'Contenido Digital', color: '#00D9FF', serviceId: 'service-contenido-digital' },
  { icon: 'ri-video-line', label: 'Edición de Video', color: '#FF006E', serviceId: 'service-edición-de-video' },
  { icon: 'ri-box-3-line', label: 'Diseño de Empaques', color: '#FFD60A', serviceId: 'service-diseño-de-empaques' },
  { icon: 'ri-printer-line', label: 'Publicidad Impresa', color: '#06FFA5', serviceId: 'service-publicidad-impresa' },
  { icon: 'ri-brush-line', label: 'Serigrafía', color: '#FF6B35', serviceId: 'service-serigrafía' },
  { icon: 'ri-code-s-slash-line', label: 'Páginas Web', color: '#00D9FF', serviceId: 'service-páginas-web' },
];

export default function About() {
  const ref = useScrollAnimation();

  return (
    <section id="about" className="py-24 md:py-32 relative bg-[#0a0a0a] overflow-hidden">
      {/* Decorative bg */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-[#FF6B35]/5 blur-3xl pointer-events-none"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-[#00D9FF]/5 blur-3xl pointer-events-none"></div>

      <div ref={ref} className="relative z-[3] max-w-7xl mx-auto px-6">
        {/* Section label */}
        <div className="fade-in-up flex items-center gap-4 mb-16">
          <span className="text-[#FF6B35] font-bebas text-lg tracking-widest">02</span>
          <div className="w-12 h-px bg-[#FF6B35]"></div>
          <span className="text-white/40 text-sm tracking-widest uppercase">Acerca de mí</span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Visual card */}
          <div className="fade-in-up relative">
            <div className="relative bg-[#111] rounded-3xl p-8 border border-white/5">
              {/* Profile image */}
              <div className="relative mb-8">
                <div className="w-full rounded-2xl overflow-hidden" style={{ aspectRatio: '3/4' }}>
                  <img
                    src="https://static.readdy.ai/image/7b80f9c748a6c492c1a0f4fbaf2d66d7/32f8d161539039f17d098afc14d4efa0.png"
                    alt="Michael Andrés Cadena Suárez - Diseñador Gráfico"
                    className="w-full h-full object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-transparent to-transparent rounded-2xl"></div>
                </div>
                {/* Badge */}
                <div className="absolute bottom-4 left-4 flex items-center gap-2 bg-black/80 backdrop-blur-sm border border-white/10 rounded-full px-4 py-2">
                  <i className="ri-map-pin-line text-[#FF6B35] text-sm"></i>
                  <span className="text-white text-sm font-medium">Bogotá, Colombia</span>
                </div>
              </div>

              {/* Stats */}
              <div className="grid grid-cols-3 gap-4">
                {[
                  { value: '5+', label: 'Años exp.', color: '#FF6B35' },
                  { value: '100+', label: 'Proyectos', color: '#00D9FF' },
                  { value: 'SENA', label: 'Formación', color: '#06FFA5' },
                ].map((s) => (
                  <div key={s.label} className="text-center p-4 bg-white/5 rounded-xl">
                    <p className="font-bebas text-3xl" style={{ color: s.color }}>{s.value}</p>
                    <p className="text-white/50 text-xs mt-1">{s.label}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Floating accent */}
            <div className="absolute -top-4 -right-4 w-24 h-24 border-2 border-[#FF6B35]/30 rounded-2xl rotate-12 pointer-events-none"></div>
          </div>

          {/* Right: Text */}
          <div className="fade-in-up">
            <h2 className="font-bebas text-5xl md:text-6xl text-white leading-tight mb-6">
              DISEÑADOR GRÁFICO
              <br />
              <span className="gradient-text">&amp; PUBLICISTA</span>
            </h2>

            <p className="text-white/70 font-poppins text-base leading-relaxed mb-6">
              Soy <strong className="text-white">Michael Andrés Cadena Suárez</strong>, diseñador gráfico y publicista con más de{' '}
              <strong className="text-white">cinco años de experiencia</strong> en el desarrollo de soluciones visuales para el sector publicitario y creativo. Cuento con{' '}
              <strong className="text-[#FF6B35]">formación técnica en impresión serigráfica del SENA</strong> y sólidos conocimientos en{' '}
              <strong className="text-[#00D9FF]">diseño gráfico</strong>,{' '}
              <strong className="text-[#00D9FF]">creación de contenido digital</strong> y{' '}
              <strong className="text-[#00D9FF]">procesos de producción gráfica</strong>.
            </p>

            <p className="text-white/70 font-poppins text-base leading-relaxed mb-6">
              Trabajo con empresas y emprendedores en el desarrollo de{' '}
              <strong className="text-[#06FFA5]">piezas visuales estratégicas</strong>, incluyendo{' '}
              <strong className="text-[#06FFA5]">empaques, etiquetas y material publicitario impreso</strong>. Además, gestiono procesos de producción e impresión, así como la estructuración de costos y presupuestos, garantizando soluciones funcionales, viables y orientadas a resultados.
            </p>

            <p className="text-white/70 font-poppins text-base leading-relaxed mb-6">
              También diseño y desarrollo{' '}
              <strong className="text-[#00D9FF]">páginas web profesionales</strong> — sitios modernos, rápidos y con identidad visual sólida para marcas, emprendedores y empresas que quieren tener presencia digital de impacto.
            </p>

            <p className="text-white/70 font-poppins text-base leading-relaxed mb-10">
              Además, cuento con conocimientos y manejo de{' '}
              <strong className="text-[#FFD60A]">herramientas de inteligencia artificial</strong> aplicadas al ámbito creativo.
            </p>

            {/* Skills */}
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-10">
              {skills.map((skill) => (
                <button
                  key={skill.label}
                  type="button"
                  onClick={() => {
                    const target = document.getElementById(skill.serviceId);
                    if (target) {
                      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      setTimeout(() => {
                        target.classList.add('service-flash');
                        setTimeout(() => target.classList.remove('service-flash'), 700);
                      }, 600);
                    }
                  }}
                  className="flex items-center gap-3 bg-white/5 hover:bg-white/10 border border-white/5 hover:border-[#06FFA5]/40 rounded-xl px-4 py-3 transition-all duration-300 cursor-pointer text-left w-full"
                >
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0" style={{ backgroundColor: `${skill.color}20` }}>
                    <i className={`${skill.icon} text-sm`} style={{ color: skill.color }}></i>
                  </div>
                  <span className="text-white/80 text-xs font-medium">{skill.label}</span>
                </button>
              ))}
            </div>

            {/* CTA */}
            <a
              href="https://wa.me/573024819377?text=Hola%20Michael%2C%20me%20interesa%20conocer%20m%C3%A1s%20sobre%20tus%20servicios"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border-2 border-[#FF6B35] text-[#FF6B35] hover:bg-[#FF6B35] hover:text-white font-semibold px-6 py-3 rounded-full transition-all duration-300 text-sm whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i>
              Hablemos de tu proyecto
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
